import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';
import { useEffect, useState } from 'react';
import styles from './index.module.scss';

interface ItemType {
    title: string;
    desc: string;
    pc: string;
    h5?: string;
    poster?: string;
    posterH5?: string;
}
const PowerOutage = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    const [enter, setEnter] = useState({
        label: false,
        title: false,
        desc: false,
    });
    const [activePanel, setActivePanel] = useState(0);
    const [isPad, setIsPad] = useState(-1);

    const items: ItemType[] = [
        {
            title: t('power_outage_item1_title'),
            desc: t('power_outage_item1_desc'),
            poster: 'https://websiteoss.ecoflow.com/figma-uploads/1756279824551-fvwwsd-compressed-1925.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/figma-uploads/1756279909908-vn1e9d-compressed-1922.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1756176468444/1.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1756176551549/1.mp4',
        },
        {
            title: t('power_outage_item2_title'),
            desc: t('power_outage_item2_desc'),
            poster: 'https://websiteoss.ecoflow.com/figma-uploads/1756279876868-02impd-compressed-1926.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/figma-uploads/1756279923581-3s09a4-compressed-1923.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1756176468604/2.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1756176551650/2.mp4',
        },
        {
            title: t('power_outage_item3_title'),
            desc: t('power_outage_item3_desc'),
            poster: 'https://websiteoss.ecoflow.com/figma-uploads/1756279895123-mprmyd-compressed-1927.jpg',
            posterH5: 'https://websiteoss.ecoflow.com/figma-uploads/1756279937823-2fjajd-compressed-1924.jpg',
            pc: 'https://websiteoss.ecoflow.com/upload/video/1756176468898/3.mp4',
            h5: 'https://websiteoss.ecoflow.com/upload/video/1756176551931/3.mp4',
        },
    ];

    useEffect(() => {
        const handleResize = () => {
            setIsPad(window.innerWidth < 768 ? 1 : 0);
        };
        handleResize();
        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const aniArr = ['label', 'title', 'desc'];
            const scenes: any = {};
            // 1. 文字动效
            aniArr.forEach((item) => {
                const domInfo: HTMLDialogElement | null = document.querySelector(`.${styles.powerOutage} .info .${item}`);
                if (domInfo) {
                    scenes[item] = AniContainer.create({
                        triggerElement: domInfo,
                        triggerHook: 1,
                        offset: domInfo.offsetHeight,
                        duration: '150%',
                        onEnter: () => setEnter((prev) => ({ ...prev, [item]: true })),
                        onLeave: () => setEnter((prev) => ({ ...prev, [item]: false })),
                    });
                }
            });
            // 2. 图片动效
            const domImg: HTMLElement | null = document.querySelector(`.${styles.powerOutage} .img-box`);
            const domImgInner: HTMLElement | null = document.querySelector(`.${styles.powerOutage} .img-box .img`);
            if (domImg && domImgInner) {
                scenes.img = AniContainer.create({
                    triggerElement: domImg,
                    triggerHook: 1,
                    offset: 0,
                    duration: domImg.offsetHeight,
                    onProcess: (n: number) => {
                        domImgInner.style.transform = `translate3d(0, ${(1 - n) * 120}px, 0)`;
                        domImgInner.style.opacity = `${n}`;
                    },
                });
            }

            // 3. 手风琴动效
            const domCollapse: HTMLElement | null = document.querySelector(`.${styles.powerOutage} .collapse-wrap`);
            const domCollapseBox: HTMLElement | null = document.querySelector(`.${styles.powerOutage} .collapse-box`);
            if (domCollapse && domCollapseBox) {
                scenes.collapse = AniContainer.create({
                    triggerElement: domCollapse,
                    triggerHook: 1,
                    offset: 0,
                    duration: domCollapseBox.offsetHeight,
                    onProcess: (n: number) => {
                        domCollapseBox.style.transform = `translate3d(0, ${(1 - n) * 120}px, 0)`;
                        domCollapseBox.style.opacity = `${n}`;
                    },
                });
            }

            return () => {
                Object.values(scenes).forEach((item: any) => item.destroy());
            };
        }
    }, []);

    return (
        <div
            className={`${styles.powerOutage} power-outage GtmModuleData-section`}
            data-section-id={styles.powerOutage}
            data-section-title={t(`power_outage_title`)}
        >
            <div className="info">
                <p className={`label${enter.label ? ' enter' : ''}`}>{t(`power_outage_label`)}</p>
                <h2 className={`title${enter.title ? ' enter' : ''}`}>{t(`power_outage_title`)}</h2>
                <p className={`desc${enter.desc ? ' enter' : ''}`}>{t(`power_outage_intro`)}</p>
            </div>
            <div className="img-box">
                <EFPicture
                    src={'https://websiteoss.ecoflow.com/figma-uploads/1756171874078-an0iqh-compressed-Frame%201612707807.png'}
                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1751270178057/PowerOutage-h5.jpg"
                    alt={t('power_outage_title')}
                    className="banner img"
                />
            </div>
            <div className="collapse-wrap">
                <div className="collapse-box">
                    <div className="collapse-info-h5">
                        <p className="collapse-title">{t('power_outage_inner_title')}</p>
                        <p className="collapse-desc">{t('power_outage_inner_desc')}</p>
                    </div>
                    <ul className="collapse-videos">
                        {items?.map((item: ItemType, k: number) => (
                            <li className={`collapse-video${activePanel === k ? ' active' : ''}`} key={k}>
                                <video
                                    src={item[isPad ? 'h5' : 'pc']}
                                    poster={item[isPad ? 'posterH5' : 'poster']}
                                    autoPlay
                                    muted
                                    preload="metadata"
                                    playsInline
                                    loop
                                    width="100%"
                                    height="100%"
                                ></video>
                            </li>
                        ))}
                    </ul>
                    <div className="collapse-content">
                        <div className="collapse-info">
                            <p className="collapse-title">{t('power_outage_inner_title')}</p>
                            <p className="collapse-desc">{t('power_outage_inner_desc')}</p>
                        </div>
                        <ul className="collapse-items">
                            {items?.map((item: ItemType, k: number) => (
                                <li className={`collapse-item${activePanel === k ? ' active' : ''}`} key={k} onClick={() => setActivePanel(k)}>
                                    <p className="collapse-item-title">
                                        <span>{item.title}</span>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M18 9L12 15L6 9" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </p>
                                    <p className="collapse-item-desc">{item.desc}</p>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PowerOutage;
